<template>
  <vwc-checkbox
    :checked="checked"
    :indeterminate="indeterminate"
    :disabled="disabled"
    @change="$emit('input', $event.target.checked)"
  />
</template>

<script>
  import '@vonage/vwc-checkbox';

  export default {
    name: 'CdCheckbox',
    // See description at https://vivid.vonage.com/?path=/story/components-atoms-checkbox--default
    components: {},
    props: {
      checked: {
        type: Boolean,
        default: false,
      },
      indeterminate: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>
